import api from '@/services/api/api';

export const useBiographiesBySlug = (slug) => {
  const biographiesSlug = useQuery(
    ['biographiesSlug', slug],
    async () => {
      const { data } = await api.biographies.getBiographyBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await biographiesSlug.suspense();
  });

  return {
    biographiesSlug,
  };
};
